// You can write more code here

/* START OF COMPILED CODE */

import ProgressBarSmall from '../GeneralUI/ProgressBarSmall';
/* START-USER-IMPORTS */
import { getDailies } from '@/game/GameComponents/PhaserGame/GameInstance';
import { RewardsManager } from '@/game/GameComponents/PhaserGame/Utils/RewardsManager';
/* END-USER-IMPORTS */

export default class DailyProgressBarWorld
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 0.3;
    this.scaleY = 0.3;

    // floater
    const floater = scene.add.container(0, 0);
    this.add(floater);

    // textBacking
    const textBacking = scene.add.image(0, 0, '1x1sprite');
    textBacking.scaleX = 320;
    textBacking.scaleY = 38;
    textBacking.setOrigin(0.5, 1);
    textBacking.alpha = 0.3;
    textBacking.alphaTopLeft = 0.3;
    textBacking.alphaTopRight = 0.3;
    textBacking.alphaBottomLeft = 0.3;
    textBacking.alphaBottomRight = 0.3;
    textBacking.tintTopLeft = 0;
    textBacking.tintTopRight = 0;
    textBacking.tintBottomLeft = 0;
    textBacking.tintBottomRight = 0;
    floater.add(textBacking);

    // bitmaptext_1
    const bitmaptext_1 = scene.add.bitmapText(
      0,
      -20,
      'Aronui',
      'Daily Progress',
    );
    bitmaptext_1.setOrigin(0.5, 0.5);
    bitmaptext_1.tintTopLeft = 15130076;
    bitmaptext_1.tintTopRight = 15130076;
    bitmaptext_1.tintBottomLeft = 15130076;
    bitmaptext_1.tintBottomRight = 15130076;
    bitmaptext_1.text = 'Daily Progress';
    bitmaptext_1.fontSize = -22;
    floater.add(bitmaptext_1);

    // progressBarSmall
    const progressBarSmall = new ProgressBarSmall(scene, -160, 10);
    floater.add(progressBarSmall);

    this.progressBarSmall = progressBarSmall;
    this.floater = floater;

    /* START-USER-CTR-CODE */
    this.setDepth(999);
    this.doProgressFeedback();

    this.scene.events.on('prerender', this.update, this);
    this.scene.events.on('pause', () => {
      this.destroy();
    });
    /* END-USER-CTR-CODE */
  }

  private progressBarSmall: ProgressBarSmall;
  private floater: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  private parent?: Phaser.GameObjects.Container;

  doProgressFeedback() {
    const yOffset = -120;
    this.floater.setY(yOffset);
    this.scene.tweens.add({
      targets: this.floater,
      y: -30 + yOffset,
      duration: 3000,
    });
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      duration: 1000,
      delay: 2000,
      onComplete: () => {
        this.destroy();
      },
    });
    // let sfx = this.scene.sound.get('world-progress-bar');
    // if (!sfx) {
    //   sfx = this.scene.sound.add('world-progress-bar');
    // }
    // sfx.play();
    this.progressBarSmall.brain.setProgressAnimated(
      RewardsManager.getTotalDailyProgress(getDailies()),
    );
  }

  update() {
    if (this.parent) {
      this.setPosition(this.parent.x, this.parent.y);
    }
  }

  setParent(parent: Phaser.GameObjects.Container) {
    this.parent = parent;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
